import type { AnyAction, Dispatch } from 'redux';

import type { EquipmentCostUtilizationChartsViewModel } from 'ab-viewModels/equipmentCostUtilization.viewModel';
import type { EquipmentUtilizationTablesViewModel } from 'ab-viewModels/equipmentUtilizationTable.viewModel';
import type { LaborUtilizationDataViewModel, LaborUtilizationChartsViewModel } from 'ab-viewModels/laborUtilization.viewModel';

import { TimePeriodSpan } from '@acceligentllc/shared/enums/timePeriodSpan';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

import API from 'af-constants/routes/api';

export function fetchEquipmentUtilizationTables(timePeriod: TimePeriodSpan = TimePeriodSpan.YEAR) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<EquipmentUtilizationTablesViewModel>(API.V1.KPI.EQUIPMENT_UTILIZATION(timePeriod));
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function fetchEquipmentCostUtilizationCharts(equipmentCostId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<EquipmentCostUtilizationChartsViewModel>(API.V1.KPI.EQUIPMENT_COST_UTILIZATION_CHARTS(equipmentCostId));
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function fetchLaborUtilizationData() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<LaborUtilizationDataViewModel>(API.V1.KPI.LABOR_UTILIZATION());
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function fetchLaborUtilizationCharts() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<LaborUtilizationChartsViewModel>(API.V1.KPI.LABOR_UTILIZATION_CHARTS());
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function refreshLaborUtilizationCache() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.post(API.V1.KPI.REFRESH_LABOR_UTILIZATION_CACHE());
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function refreshEquipmentUtilizationCache() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.post(API.V1.KPI.REFRESH_EQUIPMENT_UTILIZATION_CACHE());
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}
